import { Button } from '@/components/Button';
import Input from '@/components/Input';
import { Textarea } from '@/components/Textarea';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';

interface Props {
  onBack: () => void;
  onCreate: () => void;
  isCreating?: boolean;
  thanksPageTitle: string;
  onThanksPageTitleChange: (title: string) => void;
  thanksPageMessage: string;
  onThanksPageMessageChange: (message: string) => void;
}

export default function FormSetupTutorialStep4({
  onBack,
  onCreate,
  isCreating = false,
  thanksPageTitle,
  onThanksPageTitleChange,
  thanksPageMessage,
  onThanksPageMessageChange,
}: Props) {
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value.length <= 30) {
      onThanksPageTitleChange(value);
    }
  };

  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= 200) {
      onThanksPageMessageChange(value);
    }
  };

  return (
    <div className="flex h-[684px] flex-col overflow-hidden rounded-b-md bg-white">
      {/* メインコンテンツ部分 */}
      <div
        className="flex flex-1 flex-col items-center overflow-hidden px-x4l py-xl"
        style={{
          backgroundImage:
            'linear-gradient(119.14346197917388deg, var(--semantic/primary_lighten, rgba(237, 248, 255, 1)) 0%, var(--semantic/background/white, rgba(255, 255, 255, 1)) 30%, var(--semantic/background/white, rgba(255, 255, 255, 1)) 80%, var(--primitive/purple/50, rgba(246, 243, 255, 1)) 100%)',
        }}
      >
        <div className="flex w-full flex-col items-center gap-xl">
          {/* タイトル部分 */}
          <div className="flex flex-col items-center gap-xs">
            <h2 className="text-center text-base leading-normal font-bold text-main">
              エントリーフォームの回答完了後に表示するページの設定をしましょう！
            </h2>
            <p className="text-center text-xs leading-normal font-bold text-sub">
              （設定した内容は、後からいつでも編集することができます。）
            </p>
          </div>

          {/* フォーム部分 */}
          <div className="w-full rounded-md bg-white px-x4l py-lg shadow-[0px_0px_2px_0px_rgba(0,0,0,0.2)]">
            <div className="flex w-full flex-col gap-md">
              {/* タイトル入力 */}
              <div className="flex flex-col gap-xs">
                <label className="text-sm leading-normal font-bold text-main">タイトル</label>
                <div className="flex flex-col gap-xxs">
                  <Input
                    type="text"
                    value={thanksPageTitle}
                    onChange={handleTitleChange}
                    className="h-[42px] w-full rounded-sm border border-solid border-border px-sm"
                    maxLength={30}
                  />
                  <p className="text-xs leading-[1.7] font-normal text-sub">
                    30文字以内で入力してください。
                  </p>
                </div>
              </div>

              {/* メッセージ入力 */}
              <div className="flex flex-col gap-xs">
                <label className="text-sm leading-normal font-bold text-main">メッセージ</label>
                <div className="flex flex-col gap-xxs">
                  <Textarea
                    value={thanksPageMessage}
                    onChange={handleMessageChange}
                    className="min-h-[120px] w-full resize-none px-sm py-xs text-sm leading-[1.7] font-normal"
                    maxLength={200}
                  />
                  <p className="text-xs leading-[1.7] font-normal text-sub">
                    200文字以内で入力してください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* フッター部分 */}
      <div className="flex items-center justify-center gap-md rounded-b-md border-t border-solid border-border bg-white px-lg py-md">
        <Button color="secondary" size="md" onClick={onBack} className="gap-xxs">
          <MdArrowBack className="size-4" />
          <span>戻る</span>
        </Button>
        <Button
          color="primary"
          size="md"
          onClick={onCreate}
          disabled={isCreating}
          className="gap-xxs"
        >
          <span>設定する</span>
          <MdArrowForward className="size-4" />
        </Button>
      </div>
    </div>
  );
}
